/**
 * ArticleNavigation
 */

import Config from '../Config';
import Util from '../Util';
import Template from './Template';

class ArticleNavigation {

	public onLoaded: any;

	private $node: any;

	private $naviNode: any;

	private $naviSlick: any;

	private articleId: number;

	private currArticleId: number;

	private isFirstLoaded: boolean;

	private isLoading: boolean;

	private hasNext: boolean;

	private hasPrev: boolean;

	private nextArticle: any;

	private prevArticle: any;

	private categoryId: any;
	
	private _categoryId: string;

	private prevNext: string;

	constructor( node: any ) {
		this.$node = node;
		this.$naviNode = 'view-recent-list';
		this.$naviSlick  = '';
		this.articleId = this.currArticleId = Util.getParams().articleId;
		this._categoryId = Util.getParams().categoryId || '';
		this.isFirstLoaded = false;
		this.isLoading = false;
		this.hasNext = true;
		this.hasPrev = true;
		this.addObserver();
	}

	public getCurrentIndex() {
		return this.$node.find( `.view-recent-items[data-is-current=true]` ).index() || 0;
	}

	public getNextArticleId() {
		return this.nextArticle || '';
	}

	public getPrevArticleId() {
		return this.prevArticle || '';
	}

	public getCategoryId() {
		return this.categoryId || '';
	}

	public setData( data: any ) {
		const prev = data.prevArticles || [];
		const next = data.nextArticles || [];
		const current = data.currentArticle;
		const _currentArr = [];
		let items: any = [];

		_currentArr.push( current );

		this.prevArticle = next.length && next.reverse()[ 0 ].articleId;
		this.nextArticle = prev.length && prev[ 0 ].articleId;
		this.categoryId = (Config.isUuid) ? current.article.contentMeta.categoryBoard.id : current.category.categoryId;

		items = items.concat( next, _currentArr, prev );
		return items;
	}

	public get( articleId: string|number , size: string|number, categoryId: string  = '') {
		if ( this.isLoading ) {
			return;
		}

		if ( !articleId ) {
			return;
		}

		this.isLoading = true;

		const naviAPIUrl = Config.prevNextCombine({
			board: Config.board,
			articleId,
			categoryId: this._categoryId
		});

		const naviPromise = Util.get( naviAPIUrl, 'GET', {
			size,
		});

		const navi$ = Util.from( naviPromise );

		navi$.subscribe( ( data: any ) => {
			this.onLoaded.emit( data );
			this.isLoading = false;
		}, ( data: any ) => {
			this.isLoading = false;
		});
	}

	private addObserver() {
		this.onLoaded = new Util.Observer();
		this.onLoaded.add( ( data: any ) => {
			data = Util.convertCamelCase( data );

			if ( data.prevCurrentNextCombineArticles ) {
				data = data.prevCurrentNextCombineArticles;
			}

			const _next = data.nextArticles;
			const _prev = data.prevArticles;

			if ( this.hasNext ) {
				this.hasNext = data.hasPrev;
			}

			if ( this.hasPrev ) {
				this.hasPrev = data.hasNext;
			}

			if ( this.isFirstLoaded ) {
				if ( this.prevNext === 'prev' && _next.length ) {
					this.prevArticle = _next[ 0 ].articleId;
					this.$naviSlick.slick( 'slickAdd', this.templateList( _next.reverse() ), true );
				} else if ( this.prevNext === 'next' && _prev.length ) {
					this.nextArticle = _prev[ 0 ].articleId;
					this.$naviSlick.slick( 'slickAdd', this.templateList( _prev.reverse() ), false );
				}
			} else {
				const list = this.setData( data );
				this.$node.append( this.template( list ) );
				this.setSlick();
				this.setInitSlick();
				this.isFirstLoaded = true;
			}
		}, this);
	}

	private templateList( items: any ) {
		return Util.Tmpl.iterate({
			data: items,
			template: ( _v: any ) => {
				const _article = ( Config.isUuid ) ? _v.article.contentMeta : _v;
				const _articleId = ( Config.isUuid ) ? _article.id : _article.articleId;
				const _categoryId = ( Config.isUuid ) ? _article.categoryBoard.id : _v.category.categoryId;
				const isCurrent = ( !this.isFirstLoaded && this.articleId === _articleId ) ? 'data-is-current="true"' : '';
				const isCategoryId = ( _categoryId ) ? `&categoryId=${_categoryId}` : '';

				return `<div class="view-recent-items" data-articleId="${_articleId}" ${isCurrent}>
					<a href="view?articleId=${_articleId}${isCategoryId}">
						${( _article.thumbnailUrl ) ? `<span class="thumb"><img src="${_article.thumbnailUrl}" alt="${_article.title}" ></span>` : ''}
						<span class="number">${_article.title}</span>
					</a>
				</div>`;
			},
		});
	}

	private template( data: any ) {
		return `<div class="view-recent">
			<div class="${this.$naviNode}">${this.templateList( data )}</div>
		</div>`;
	}

	private setInitSlick() {
		this.$naviSlick.slick( 'slickGoTo', this.getCurrentIndex(), true );
	}

	private setSlick() {
		this.$naviSlick = jQuery( `.${this.$naviNode}` );

		if ( !this.$naviSlick.slick ) {
			return;
		}

		if ( this.$naviSlick.hasClass('slick-initialized') ) {
			this.$naviSlick.slick( 'unslick' );
		}

		this.$naviSlick.slick({
			infinite: false,
			speed: 300,
			slidesToShow: 5,
			slidesToScroll: 5,
			dots: true,
			arrows: true,
			prevArrow: '<button class="slick-arrow slick-prev"><i class="fe-icon-chevron_left"></i></button>',
			nextArrow: '<button class="slick-arrow slick-next"><i class="fe-icon-chevron_right"></i></button>',
			responsive: [{
				breakpoint: 960,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					},
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
			],
		});

		this.$naviSlick.on( 'beforeChange', ( event: any, slick: any, currentSlide: any, nextSlide: any ) => {
			if ( ( ( nextSlide === 0 && currentSlide === 0 ) || currentSlide > nextSlide ) && this.hasPrev ) {
				this.prevNext = 'prev';
				this.get( this.getPrevArticleId(), Config.prevNextNavigationSize, this.getCategoryId() );
			} else if ( currentSlide < nextSlide && this.hasNext ) {
				this.prevNext = 'next';
				this.get( this.getNextArticleId(), Config.prevNextNavigationSize, this.getCategoryId() );
			}
		});
	}
}

export default ArticleNavigation;
